import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import forEach from 'lodash/forEach';
import noop from 'lodash/noop';
import find from 'lodash/find';
import map from 'lodash/map';
import get from 'lodash/get';
import intersection from 'lodash/intersection';
import classNames from 'classnames/bind';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import Button from 'yoda-core-components/lib/components/Button';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { getAdditionalServices } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import selectPpId from 'yoda-site-components/lib/selectors/productDetails/selectPpId';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import AddToCartInterstitialLazy from 'yoda-checkout-components/lib/components/AddToCartInterstitial/AddToCartInterstitialLazy';
import ApplyCouponInputBox from 'yoda-checkout-components/lib/components/Coupons/ApplyCouponInputBox/ApplyCouponInputBox';
import RoundupForCharityLearnMore from 'yoda-checkout-components/lib/components/RoundupForCharity/RoundupForCharityLearnMore';
import ShippingProtectionModalLazy from 'yoda-checkout-components/lib/components/ShippingProtection/ShippingProtectionModalLazy';
// import ShippingProtectionCheckout from 'yoda-checkout-components/lib/components/ShippingProtection/ShippingProtectionCheckout';
import * as findStoresAction from 'yoda-site-components/lib/actions/FindStoresAction';
import ClientLoggerAction from 'yoda-site-components/lib/actions/ClientLoggerAction';
import * as LocationServiceAction from 'yoda-site-components/lib/actions/LocationServiceAction';
import * as COAdjustmentAction from 'yoda-checkout-components/lib/actions/COAdjustmentAction';
import * as COCouponAction from 'yoda-checkout-components/lib/actions/COCouponAction';
import * as applePayAction from 'yoda-checkout-components/lib/actions/PayWithAppleAction';
import * as googlePayAction from 'yoda-checkout-components/lib/actions/PayWithGoogleAction';
import * as COAdjustmentActionTypes from 'yoda-checkout-components/lib/actionTypes/COAdjustmentActionTypes';
import siteAnalyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import * as CheckoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import * as slidePanelActions from 'yoda-checkout-components/lib/actions/SlidePanelAction';
import * as changeStoreSliderActions from 'yoda-checkout-components/lib/actions/ChangeStoreSliderAction';
import * as serviceErrorActions from 'yoda-checkout-components/lib/actions/ServiceErrorHandlerAction';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import TokenProvider, {
    setValue,
} from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import {
    getViewPort,
    getCurrentProduct,
    getWarrantyDetails,
    isGiftCardOrderOnly,
    loadApplePaySDK,
} from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import {
    updateCartUID,
    getURLParameterBykey,
    scrollToElement,
} from 'yoda-checkout-components/lib/helpers/Utils/ATCCommonUtils';
import { ENTER_COUPON_OR_REWARD_OR_GIFT } from 'yoda-checkout-components/lib/common/LabelConstants';
import {
    CURRENCY_US,
    ADJUSTMENT_TYPE_REWARD,
    ADJUSTMENT_TYPE_ASSOC_DISCOUNT,
    ADJUSTMENT_TYPE_SHIPPING,
    ADJUSTMENT_TYPE_RESTRICTED,
    ADJUSTMENT_TYPE_COUPON,
    SHIP_TO_STORE_LABELS_LABEL_CHANGE_STORE,
    ANALYTICS_ACTIONS_PRODUCT_CO_OOS,
    IRIS_MARKETING_SLOT,
    URL_CART_PAGE,
    HOLIDAY_BOPIS_MESSAGE_CONTENT,
    CURBSIDE_CART_CONTENT,
    GOOGLE_ADS_CART_PAGE_BOTTOM_LEFT,
} from 'yoda-checkout-components/lib/common/Constants';

import * as showGlobalLoaderAction from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import LiveChat from 'yoda-checkout-components/lib/components/LiveChat/LiveChat';
import * as signinActions from 'yoda-site-components/lib/actions/AccountAction';
import * as atcSliderStatusAction from 'yoda-site-components/lib/actions/AtcSliderStatusAction';
import DelaySpinner from 'yoda-checkout-components/lib/components/DelaySpinner/DelaySpinner';
import ServiceErrorMessage from 'yoda-checkout-components/lib/components/ServiceErrorMessage/ServiceErrorMessage';
import splunkLogsActions from 'yoda-checkout-components/lib/actions/SplunkLogsActions';
import OOSModal from 'yoda-checkout-components/lib/components/OOSModal/OOSModalLazy';
import * as messageContentAction from 'yoda-checkout-components/lib/actions/MessageContentAction';
import { CART_PAGE_URL, FIND_STORES_PAGE_SIZE } from 'yoda-site-components/lib/common/Constants';
import User from 'yoda-site-components/lib/helpers/User/User';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import QuickScreenLazy from 'yoda-account-components/lib/components/SYFQuickScreen/QuickScreenLazy';
import { isQuickScreenEligible } from 'yoda-account-components/lib/helpers/Utils/Utils';
import PLCCSlidePanelLazy from 'yoda-site-components/lib/components/PLCCSlidePanel/PLCCSlidePanelLazy';
import { getRewardId } from 'yoda-site-components/lib/actions/NativeAppAction';
import EarnRewardsPointsLazy from 'yoda-checkout-components/lib/components/EarnRewardsPoints/EarnRewardsPointsLazy';
import PageBanners from 'yoda-checkout-components/lib/components/PageBanners/PageBanners';
import RecommendationSwitch from 'yoda-site-components/lib/components/RecommendationSwitch/RecommendationSwitch';
import {
    isFeatureEnabledFromCookie,
    isAgentLogged,
    detectSafari,
} from 'yoda-core-components/lib/helpers/Utils/Utils';
import AccessTokenProviderAction from 'yoda-site-components/lib/actions/AccessTokenProviderAction';
import Rewards from '../../../../assets/static/images/NewRewards.svg';
import MarketingS1Slot from '../../../../components/MarketingS1Slot/MarketingS1Slot';
import * as cartDetailsAction from '../../../../actions/GetCartDetailsAction';
import {
    getMarketingSlotBanner,
    getIrisMarketingSlotBanner,
} from '../../../../actions/GetMarketingSlotBannerAction';
import { initGiftCardBannerInfo } from '../../../../actions/GiftCardBannerAction';
import EmptyCart from '../../../../components/EmptyCart/EmptyCart';
import CartItemsList from '../../../../components/CartItemsList/CartItemsList';
import FindBestCoupon from '../../../../components/FindBestCoupon/FindBestCoupon';
import CouponApplied from '../../../../components/CouponApplied/CouponApplied';
import SpecialOffers from '../../../../components/SpecialOffers/SpecialOffers';
import { SavedItemsList as SavedItemsLazy, SavedItemsList } from '../LazyModules/SavedItemsLazy';

import { SingleClickCheckoutWrapper } from '../LazyModules/CartPageWrapperComponentsLazy';
import { getPLCCDetailsHtml } from '../../../../actions/PlccDynamicBannerAction';
import { WEB_GET_REWARD_PROFILE_REQUEST_POINTS_EARNED } from '../../../../actionTypes/CartActionTypes';
import styles from './CartPageWrapper.css';

import OrderSummaryWrapper from '../../../../components/OrderSummaryWrapper/OrderSummaryWrapper';
import OrderSummaryWrapperMobile from '../../../../components/OrderSummaryWrapper/OrderSummaryWrapperMobile';
import CartBanners from '../../../../components/CartBanners/CartBanners';
import CartMessages from '../../../../components/CartMessages/CartMessages';
import InvalidCouponInfoMessage from '../../../../components/CartMessages/InvalidCouponInfoMessage';
import CartService from '../../../../services/CartService';

const cx = classNames.bind(styles);
let isEmptyCartLogged = false;
export class CartPageWrapper extends SiteComponent {
    constructor(props) {
        /* istanbul ignore next */
        super(props);
        this.state = {
            contextList: ['CART'],
            showPLCCDetailSlider: false,
            showQSBannerInS1Slot: false,
            toShowLearnMoreState: false,
            toShowSeeDetailsState: false,
            enableQSBanner: false,
            isBnplApplied: false,
        };
        this.isBetterCouponAvailable = false;
        this.isGiftCardBannerShown = false;
        this.isGiftCardRegularItemErrAnalyticsTriggered = false;
        this.totalExceededErrorAnalyticsTriggered = false;
        this.isGiftCardPaymentErrAnalyticsTriggered = false;
        this.togglePLCCDetailSlider = this.togglePLCCDetailSlider.bind(this);
        this.resizeObserver = null;
        this.renderFPACorBestCoupon = this.renderFPACorBestCoupon.bind(this);
        this.handleApplyRewardsSection = this.handleApplyRewardsSection.bind(this);
        this.handleMetaTokenInfo = this.handleMetaTokenInfo.bind(this);
        this.loadCartIfNeeded = this.loadCartIfNeeded.bind(this);
    }

    handleMetaTokenInfo(isFromMeta) {
        if (!__SERVER__ && isFromMeta && !isEmpty(this.props.metaTokenInfo)) {
            TokenProvider.storeTokenFromServer(this.props.metaTokenInfo);
            this.props.actions.clearMetaTokenInfo();
        }
    }

    loadCartIfNeeded(isFromMeta) {
        const { featureFlags: { enableForceCloud6 = false } = {} } = this.props;
        if (!__SERVER__ && isFromMeta && enableForceCloud6) {
            setValue('DP-Cloud-Origin', 'cloud6', true);
        }
        if (isEmpty(this.props.orderInfo) && !this.props.loadEmptyCart) {
            this.props.actions.showGlobalLoader(true);
            this.props.actions.getCartDetails({ ...this.props.headers, isFromMeta });
        }
    }

    hydrateOnMount() {
        if (isEmpty(this.props.marketingSlotBanner) && !__SERVER__) {
            !__SERVER__
                ? this.props.actions.getIrisMarketingSlotBanner(IRIS_MARKETING_SLOT[getViewPort()])
                : this.props.actions.getMarketingSlotBanner();
        }
        const { isFromMeta, isMetaUANotFound } = CartService.isFromMetaPlatform(this.props.context);
        this.handleMetaTokenInfo(isFromMeta);
        this.loadCartIfNeeded(isFromMeta);
        if (isMetaUANotFound) this.props.actions.logMetaUADetails(this.props.headers);
        // if refetch has been instructed from server side
        /* istanbul ignore next */
        if (!__SERVER__ && get(this.props, 'cartDetails.data.bag.reload', false)) {
            const syncStoreId = get(this.props, 'cartDetails.data.bag.syncStoreId', 0);
            if (syncStoreId) {
                this.props.actions.updateStoreOnCartAction(syncStoreId);
                setTimeout(() => {
                    this.props.actions.getCartDetails({ preventCartSync: true });
                }, 1e3);
            }
        }

        if (!__SERVER__ && !isEmpty(this.props.cartDetails)) {
            updateCartUID(this.props.cartDetails);
        }
    }

    componentWillReceiveProps(nextProps) {
        // Empty cart client side logging
        const cartLoggingStorage = LocalStorage.getData('DP_EMPTY_CART_LOGGING', true) || 'false';
        const isUpdatedManually =
            LocalStorage.getData('CART_UPDATED_MANUALLY', 'CART_UPDATED_MANUALLY') || 'false';
        const itemCountCookie = Cookies.load('ItemCount');
        const accountID = Cookies.load('ACCOUNT_ID') || LocalStorage.getData('ACCOUNT_ID');

        if (cartLoggingStorage === 'false' && itemCountCookie > 0) {
            isEmptyCartLogged = false;
            LocalStorage.setData('DP_EMPTY_CART_LOGGING', 'true', true);
        }
        // check DP_EMPTY_CART_LOGGING value before logging
        const hasItemInCart = LocalStorage.getData('DP_EMPTY_CART_LOGGING', true) || 'false';
        const isItemCountEmpty = !itemCountCookie || itemCountCookie === '0';
        if (
            !isEmptyCartLogged &&
            accountID &&
            hasItemInCart === 'true' &&
            isUpdatedManually === 'false' &&
            isItemCountEmpty
        ) {
            LocalStorage.setData('DP_EMPTY_CART_LOGGING', 'false', true);
            this.props.actions.logError('Lost cart Encountered');
            isEmptyCartLogged = true;
        }
        if (isItemCountEmpty && hasItemInCart === 'true' && isUpdatedManually === 'true') {
            LocalStorage.setData('DP_EMPTY_CART_LOGGING', 'false', true);
        }
        if (nextProps?.marketingSlotBanner?.content?.components?.length > 0) {
            this.state.showQSBannerInS1Slot = false;
        } else {
            this.state.showQSBannerInS1Slot = true;
        }
        if (
            this.props?.cartDetails?.data !== nextProps?.cartDetails?.data &&
            !this.props.disableEarnRewardsBanner &&
            !__SERVER__ &&
            this.props.isNativeAndroid &&
            !TokenProvider.get('DP_REWARDS_TIER')
        ) {
            this.props.actions.getRewardId(WEB_GET_REWARD_PROFILE_REQUEST_POINTS_EARNED);
        }
        if (
            this.props?.signInSliderDetails?.authenticationSuccess !==
                nextProps?.signInSliderDetails?.authenticationSuccess &&
            this.props?.signInSliderDetails?.confirmCreateAccountPage !==
                nextProps?.signInSliderDetails?.confirmCreateAccountPage &&
            nextProps.signInSliderDetails?.authenticationSuccess &&
            nextProps.signInSliderDetails?.confirmCreateAccountPage
        ) {
            this.props.actions.getCartDetails();
        }
    }

    componentWillUpdate(nextProps) {
        if (
            this.props.isAdjustmentsUpdated !== nextProps.isAdjustmentsUpdated &&
            nextProps.isAdjustmentsUpdated
        ) {
            this.props.actions.getCartDetails();
        }
        if (
            this.props.updateAdjustmentStatus.result !== nextProps.updateAdjustmentStatus.result &&
            nextProps.updateAdjustmentStatus.status &&
            nextProps.updateAdjustmentStatus.status ===
                COAdjustmentActionTypes.CO_ADJUSTMENT_EXPIRED
        ) {
            this.props.actions.removeCOAdjustmentById(nextProps.updateAdjustmentStatus.id);
        }
        if (
            this.props.oosDetails !== nextProps.oosDetails &&
            !isEmpty(get(nextProps, 'oosDetails.discontinuedOOSDetails.oosItemProducts'))
        ) {
            this.props.actions.clickEventAnalyticsAction(ANALYTICS_ACTIONS_PRODUCT_CO_OOS);
            this.props.featureFlags.splunkLogs &&
                this.props.featureFlags.splunkLogs.enableOOSLogs &&
                this.props.actions.logInSplunk({
                    name: 'CART PAGE LOG',
                    value: `ITEMS OOS skuIds = ${nextProps.oosDetails.discontinuedOOSDetails.oosItemProducts.toString()}`,
                    orderId: this.props.orderInfo.id,
                });
        }
    }

    onAnalyticsCallback = () => {
        this.props.actions.openModelEvent({ name: SHIP_TO_STORE_LABELS_LABEL_CHANGE_STORE });
    };

    onCloseFindStorePanel = () => {
        const zipCode = getURLParameterBykey('zipcode');
        if (zipCode) {
            getBrowserHistory().push(URL_CART_PAGE);
        }
    };

    onSelectStoreFromPanel = (callbackParam) => {
        const { actions } = this.props;
        this.onCloseFindStorePanel();
        actions.selectStore(callbackParam);
    };

    componentDidMount() {
        const {
            oosDetails,
            orderInfo,
            actions,
            messageContentData,
            isNative,
            disableCartLineItemReadyForPickupMsg,
            enableGiftCardBanner,
            featureFlags,
            preferences,
            disableEarnRewardsBanner,
        } = this.props;
        const enableNativeApplepay = !isNative || (featureFlags.enableNativeApplepay ?? true);
        const enableNonSafariApplePay = !isNative && (featureFlags.enableNonSafariApplePay ?? true);
        const enableNativeNonSafariApplePay =
            isNative && (featureFlags.enableNativeNonSafariApplePay ?? true);
        if (!detectSafari() && (enableNonSafariApplePay || enableNativeNonSafariApplePay)) {
            loadApplePaySDK({
                src: get(
                    preferences,
                    'applePaySdkUrl',
                    'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js'
                ),
                crossorigin: 'anonymous',
                onSuccess: () => this.props.actions.setApplePayAccountEligible(),
            });
        } else if (enableNativeApplepay) {
            this.props.actions.setApplePayAccountEligible();
        }
        this.props.actions.setGooglePayAccountEligible(this.props.actions);
        if (enableGiftCardBanner) {
            actions.initGiftCardBannerInfo();
        }
        if (orderInfo.showCurbsideBanner) {
            actions.getMessageContent(CURBSIDE_CART_CONTENT);
        }
        SavedItemsLazy.preload();
        if (!isEmpty(get(oosDetails, 'discontinuedOOSDetails.oosItemProducts'))) {
            this.props.actions.clickEventAnalyticsAction(ANALYTICS_ACTIONS_PRODUCT_CO_OOS);
            this.props.featureFlags.splunkLogs &&
                this.props.featureFlags.splunkLogs.enableOOSLog &&
                this.props.actions.logInSplunk({
                    name: 'CART PAGE LOG',
                    value: `ITEMS OOS skuIds = ${oosDetails.discontinuedOOSDetails.oosItemProducts.toString()}`,
                    orderId: orderInfo.id,
                });
        }
        // Show rewards slide-over if we see action query param as 'rewardsSlideover'
        const showRewardsSlider = getURLParameterBykey('action');

        if (showRewardsSlider === 'rewardsSlideover') {
            actions.showRewardsPanel(true);
        }
        if (showRewardsSlider === 'rewardsSignInSlideover') {
            actions.showRewardsPanel(true);
            actions.showRewardsPanelSignIn(true);
        }
        // Show findStores slide-over if we see action query param as 'zipcode'
        const zipCode = getURLParameterBykey('zipcode');
        if (zipCode) {
            this.openFindStoreSlider({ zipCode });
        }

        if (
            !(messageContentData && messageContentData[HOLIDAY_BOPIS_MESSAGE_CONTENT]) &&
            !disableCartLineItemReadyForPickupMsg
        ) {
            actions.getMessageContent(HOLIDAY_BOPIS_MESSAGE_CONTENT);
        }
        if (
            !disableEarnRewardsBanner &&
            !__SERVER__ &&
            isNative &&
            !TokenProvider.get('DP_REWARDS_TIER')
        ) {
            this.props.actions.getRewardId(WEB_GET_REWARD_PROFILE_REQUEST_POINTS_EARNED);
        }
        this.setState({
            enableQSBanner: isQuickScreenEligible({ isNative, featureFlags, preferences }),
        });
    }

    componentDidUpdate() {
        const { showGiftCardBanner, showGlobalLoader } = this.props;
        if (this.totalExceededError && !showGlobalLoader) {
            scrollToElement(this.totalExceededError);
        }
        // DA => Trigger Gift card track analytics event
        if (!this.isGiftCardBannerShown && showGiftCardBanner) {
            this.props.actions.giftCardBannerAnalyticsAction();
            this.isGiftCardBannerShown = true;
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
    }

    togglePLCCDetailSlider() {
        const { plccDynamicBanner } = this.props;
        if (
            !this.state.showPLCCDetailSlider &&
            plccDynamicBanner?.detailsLink?.url &&
            !plccDynamicBanner?.detailsHtml
        ) {
            this.props.actions.getPLCCDetailsHtml(plccDynamicBanner?.detailsLink?.url);
        }
        this.setState({
            showPLCCDetailSlider: !this.state.showPLCCDetailSlider,
        });
    }

    isCouponAdjustment = (item) => {
        return get(item, 'code') === ADJUSTMENT_TYPE_COUPON;
    };

    isRestrictedAdjustment = (item) => {
        return get(item, 'restrictionType') === ADJUSTMENT_TYPE_RESTRICTED;
    };

    fpacAdjustmentMatch(item) {
        return this.isCouponAdjustment(item) || this.isRestrictedAdjustment(item);
    }

    // Below method decides if we have to show FPAC experience
    showFPACExperience = () => {
        let showFPAC = true;
        const { coCoupons, orderAdjustments, enableSupressBestCoupon } = this.props;
        if (enableSupressBestCoupon) {
            return false;
        }
        const bestCouponObj = find(coCoupons.groups, { id: 'BESTCOUPONS' });
        const OnlineOnlyType = (coupon) =>
            coupon.channel &&
            ['ONLINE_AND_IN_STORE', 'ONLINE_ONLY', 'all', 'online'].includes(coupon.channel.type);
        const genericBestCoupon = get(bestCouponObj, 'coupons', []);
        const bestCouponsList = genericBestCoupon.filter(OnlineOnlyType);
        if (isEmpty(bestCouponsList)) return false;
        const bestCouponFoundinList =
            !isEmpty(bestCouponsList) && this.getBestCouponWithMostDiscount(bestCouponObj);
        if (!bestCouponFoundinList) return false;
        forEach(orderAdjustments, (item) => {
            const isBetterDiscount =
                this.fpacAdjustmentMatch(item) &&
                item.subType !== ADJUSTMENT_TYPE_SHIPPING &&
                item.amount >= bestCouponFoundinList.totalDiscount;
            const isSameCoupon = item.value === bestCouponFoundinList.code;
            if (isBetterDiscount || isSameCoupon) {
                showFPAC = false;
            }
        });
        /* istanbul ignore next */
        if (isEmpty(orderAdjustments)) {
            this.isBetterCouponAvailable = false;
        }
        forEach(orderAdjustments, (item) => {
            if (
                item.code === ADJUSTMENT_TYPE_COUPON &&
                item.code !== ADJUSTMENT_TYPE_ASSOC_DISCOUNT &&
                item.subType !== ADJUSTMENT_TYPE_SHIPPING &&
                item.amount <= bestCouponFoundinList.totalDiscount
            ) {
                this.isBetterCouponAvailable = true;
            } else {
                this.isBetterCouponAvailable = false;
            }
        });
        return showFPAC;
    };

    // below method gets an object maximun discount availalble in best coupons
    getBestCouponWithMostDiscount = (bestCouponObj) => {
        const bestCoupon =
            bestCouponObj &&
            bestCouponObj.coupons.reduce((prev, current) =>
                prev.totalDiscount > current.totalDiscount ? prev : current
            );
        return bestCoupon;
    };

    /**
     * To check Coupon applied & apllied coupon
     *  is BestCoupon or OnlineCoupon
     */
    appliedCouponBestOrOnline = () => {
        const { coCoupons, orderAdjustments } = this.props;
        const bestCouponArray = find(coCoupons.groups, { id: 'BESTCOUPONS' });
        const bestCouponsList = get(bestCouponArray, 'coupons', []);
        const onlineCouponObj = find(coCoupons.groups, { id: 'ONLINEORSTORECOUPONS' });
        const onlineCouponsList = get(onlineCouponObj, 'coupons', []);

        let appliedCoupon = '';
        let couponAppliedValue = '';
        if (!isEmpty(orderAdjustments)) {
            forEach(orderAdjustments, (item) => {
                if (
                    item.code === ADJUSTMENT_TYPE_COUPON &&
                    item.subType !== ADJUSTMENT_TYPE_SHIPPING &&
                    item.amount > 0
                ) {
                    couponAppliedValue = item.value;
                }
            });
            /* istanbul ignore else */
            if (!isEmpty(couponAppliedValue)) {
                appliedCoupon = find(bestCouponsList, { code: couponAppliedValue });
            }
            if (
                isEmpty(appliedCoupon) &&
                !isEmpty(couponAppliedValue) &&
                !this.showFPACExperience()
            ) {
                appliedCoupon = find(onlineCouponsList, { code: couponAppliedValue });
            }
        }
        return appliedCoupon;
    };

    /**
     * To Display Best Coupon
     */
    renderFPACorBestCoupon(isSmallerScreen) {
        const {
            coCoupons,
            orderAdjustments,
            deviceType,
            coAppliedAdjustments,
            showGlobalLoader,
            enableNewOrderSummaryRedesign,
            enableBestCouponCTA,
        } = this.props;
        const idSuffix = isSmallerScreen ? '-mobile' : '';
        const appliedCoupon = this.appliedCouponBestOrOnline();

        const appliedCouponObj = {};
        if (!isEmpty(orderAdjustments)) {
            forEach(orderAdjustments, (item) => {
                if (
                    item.code === ADJUSTMENT_TYPE_COUPON &&
                    item.subType !== ADJUSTMENT_TYPE_SHIPPING &&
                    item.amount > 0
                ) {
                    appliedCouponObj.value = item.value;
                    appliedCouponObj.amount = item.amount;
                    appliedCouponObj.message = item.message || '';
                    appliedCouponObj.appOnly = item.appOnly;
                }
            });
        }
        const bestCouponObj = find(coCoupons.groups, { id: 'BESTCOUPONS' });
        const noBestCouponAvailable =
            !this.showFPACExperience(coCoupons, orderAdjustments) && !appliedCoupon;
        const showCouponApplied =
            (!isEmpty(appliedCoupon) || noBestCouponAvailable) && !isEmpty(appliedCouponObj);
        const showSpecialOffers = this.showFPACExperience(coCoupons, orderAdjustments);
        /* istanbul ignore next */
        if (showCouponApplied || showSpecialOffers) {
            return (
                <>
                    <CouponApplied
                        orderAdjustments={appliedCouponObj}
                        deviceType={deviceType}
                        display={showCouponApplied}
                    />
                    {enableBestCouponCTA && (
                        <SpecialOffers
                            bestCoupon={this.getBestCouponWithMostDiscount(bestCouponObj)}
                            applyCOAdjustment={this.props.actions.applyCOAdjustment}
                            isBetterCouponAvailable={this.isBetterCouponAvailable}
                            deviceType={deviceType}
                            errorInfo={coAppliedAdjustments && coAppliedAdjustments.error}
                            display={showSpecialOffers}
                            showGlobalLoader={showGlobalLoader}
                            isSmallerScreen={isSmallerScreen}
                            idSuffix={idSuffix}
                        />
                    )}
                    {!deviceType.isDesktop && <InvalidCouponInfoMessage />}
                </>
            );
        }
        return (
            <div
                className={`${cx('hiddenSm', 'hiddenTwMd', 'lg12', 'xl12', 'todayCoupon')} ${dt([
                    'w-full',
                    'p-0',
                    enableNewOrderSummaryRedesign && 'mb-2',
                ])}`}
            >
                <FindBestCoupon idSuffix={idSuffix} />
            </div>
        );
    }

    getChangeStoreSliderProps = () => {
        const { actions, orderItems, messageContentData } = this.props;

        return {
            productDetails: map(orderItems, (orderItem) => orderItem.product),
            findStoresAction: actions.findStores,
            selectStoreAction: this.onSelectStoreFromPanel,
            selectActionCallback: actions.getCartDetails,
            openPanelAnalyticsCallback: this.onAnalyticsCallback,
            findMoreStores: actions.findMoreStores,
            onClosePanel: this.onCloseFindStorePanel,
            hideContentScroll: true,
            bopisHolidayMessage: get(
                messageContentData,
                `${HOLIDAY_BOPIS_MESSAGE_CONTENT}.body`,
                ''
            ),
            enableProductCardImage: false,
            enableSlimFindStores: true,
        };
    };

    /**
     * Opens the find store slider
     * @param {Object} params object to send to find store slider
     */
    openFindStoreSlider = (params) => {
        const { actions, zipCode, defaultRadius } = this.props;
        const payload = {
            miles: defaultRadius,
            zipCode,
            showCartItemAvailability: true,
            showAvailable: false,
            pageSize: FIND_STORES_PAGE_SIZE,
            xClientSource: 'SLIDER',
            ...params,
        };

        // checks weather a numeric zipCode is present
        if (parseInt(zipCode)) {
            actions.findStores(payload);
        }

        // opens the 2021 bopis improvement slider
        actions.setFindStoreSliderProps(this.getChangeStoreSliderProps());

        actions.openSlidePanel();
    };

    openRewardPanel = () => {
        const { actions, isCheckout } = this.props;
        this.props.actions.clearServiceErrorMessage();
        actions.getCOCouponsAction(true, isCheckout);
        actions.showRewardsPanel(true);
    };

    handleApplyRewardsSection(isSmallerScreen = false) {
        const { enableNewOrderSummaryRedesign, enableRewards } = this.props;
        const idSuffix = isSmallerScreen ? '-mobile' : '';
        const couponDivStyles = enableNewOrderSummaryRedesign
            ? dt([
                  'bg-light-white',
                  'justify-center',
                  'relative',
                  'overflow-visible',
                  'pt-4',
                  'pb-6',
                  'lg:mb-6',
                  'lg:rounded-b-lg',
                  'mdOnly:px-2',
                  'block',
                  'px-6',
              ])
            : dt([
                  'bg-light-white',
                  'justify-center',
                  'relative',
                  'overflow-visible',
                  'py-4',
                  'mdOnly:px-2',
                  'block',
                  'px-6',
              ]);
        return (
            <div className={`${dt(['mt-2'])} ${cx('summaryRewardsSection')} `}>
                {enableRewards &&
                    (enableNewOrderSummaryRedesign ? (
                        <div
                            className={`
                        ${cx('applyAndManageRewards')}
                        ${dt([
                            'bg-light-white',
                            'justify-between',
                            'flex',
                            'flex-row',
                            'items-center',
                            'sm:pt-6',
                            'lg:pt-5',
                            'px-6',
                            'mdOnly:px-2',
                            'text-black',
                            'lg:rounded-t-lg',
                        ])}
                    `}
                        >
                            <div className={dt(['text-xlarge', 'font-bold'])}>More Savings</div>
                            <Button
                                buttonId="apply-rewards"
                                buttonType="Link"
                                size="Sm"
                                automationId="apply-and-manage-rewards"
                                className={`${cx('viewAndManage', 'newRewardsTitle')}
                                ${dt(['flex', 'items-center'])}
                            `}
                                onClick={this.openRewardPanel}
                            >
                                <Icon
                                    automationId="at-rewards-link"
                                    iconType="svg"
                                    width="32px"
                                    height="32px"
                                    viewBox="0 0 32 32"
                                    className={dt(['mr-1'])}
                                >
                                    <Rewards />
                                </Icon>
                                <span className={cx('getRewardsText')}>Get Your Rewards</span>
                            </Button>
                        </div>
                    ) : (
                        <div
                            className={`
                            ${cx('applyAndManageRewards')}
                            ${dt([
                                'bg-light-white',
                                'justify-center',
                                'flex',
                                'flex-row',
                                'cursor-pointer',
                                'lg:pt-6',
                                'sm:pt-4',
                                'text-black',
                                'lg:rounded-t-lg',
                            ])}
                        `}
                        >
                            <Button
                                buttonId="apply-rewards"
                                buttonType="Link"
                                size="Sm"
                                automationId="apply-and-manage-rewards"
                                className={`${cx('viewAndManage')}
                                ${dt([
                                    'underline',
                                    '!font-open-sans-semibold',
                                    'pt-2',
                                    '!font-bold',
                                ])}
                            `}
                                onClick={this.openRewardPanel}
                            >
                                View and Manage Rewards
                            </Button>
                        </div>
                    ))}
                {!isAgentLogged() && (
                    <div className={couponDivStyles} data-automation-id="at-coupon-input-box-block">
                        <div className={cx('applyCouponSection')}>
                            <ApplyCouponInputBox
                                customInputClass={dt(['!border-r-0'])}
                                buttonType="Primary"
                                buttonClass={dt(['!text-base'])}
                                placeholder={ENTER_COUPON_OR_REWARD_OR_GIFT}
                                channel="BOF"
                                inline
                                pageInfo="cart"
                                section={ENTER_COUPON_OR_REWARD_OR_GIFT}
                                idSuffix={idSuffix}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    continueToCart = () => {
        window.location.href = CART_PAGE_URL;
    };

    scrollToSFL = () => {
        const container = document.getElementById('saved-for-later');
        if (container) {
            container.scrollIntoView({ behavior: 'smooth' });
        }
    };

    renderS1() {
        return <MarketingS1Slot mountOnServer deviceType={this.props.deviceType} />;
    }

    closeCartModal = () => {
        this.props.actions.showCartATCSlider(false);
    };

    removeLoader = () => {
        this.props.actions.showGlobalLoader(false);
    };

    getCurrentLot = () => {
        const { interstitialSelectedSkuId, productDetails } = this.props;
        let currentLot = '';
        productDetails.lots.forEach((lot) => {
            lot.items &&
                lot.items.forEach((item) => {
                    if (item.id === interstitialSelectedSkuId) {
                        currentLot = lot;
                    }
                });
        });
        return currentLot;
    };

    renderAdditionalServices = () => {
        this.props.actions.showCartATCSlider(true);
        const { interstitialSelectedSkuId, interstitialSelectedItem } = this.props;
        const selectedProtPlan = getCurrentProduct(
            [interstitialSelectedItem],
            interstitialSelectedSkuId
        );
        const selectedId = get(selectedProtPlan && selectedProtPlan[0], 'sku.id', '');
        const protectionInfo = getWarrantyDetails(this.getCurrentLot(), selectedId);
        return (
            <ErrorBoundary>
                <AddToCartInterstitialLazy
                    sku={this.props.interstitialSelectedSkuId}
                    deliveryServiceInfo={this.props.additionalServices}
                    showAddToCart
                    ppId={this.props.ppId}
                    onCloseAddToCart={this.closeCartModal}
                    carePlanInfo={get(protectionInfo, 'warranties', [])}
                    careplanAcceptAnalyticsFunc={noop}
                    warrantyDetails={get(
                        protectionInfo,
                        'includedProtectionPlan[0].description',
                        ''
                    )}
                    numberOfItems={this.props.orderInfo.itemsCount}
                    carePlanAcceptAnalytics={noop}
                    removeLoader={this.removeLoader}
                    cartAdditionalServices
                />
            </ErrorBoundary>
        );
    };

    renderProductCartridge() {
        const {
            featureFlags: { enableCartCertonaZone = true },
            preferences,
        } = this.props;

        const slots = get(preferences, 'recommendations.slots', []);
        if (!enableCartCertonaZone || !slots.length) {
            return null;
        }

        const isEmptyCartCertona = isEmpty(this.props.certonaAttributes?.itemid);
        const pageType = isEmptyCartCertona ? 'emptycart' : 'cart';
        const cartSlots = slots.filter((s) => s.pageType === pageType);
        if (!cartSlots.length) return null;

        const itemId = (this.props.certonaAttributes?.cartIds || '').split(',');
        const prodCatridgeClassName = `${cx(
            'lg12',
            'xl12',
            'noPad',
            'prodCartridgeWrapper',
            isEmptyCartCertona ? 'blockWithoutCart' : 'blockWithCart'
        )} ${dt(['!block', isEmptyCartCertona ? '' : 'lg:!pr-2'])}`;

        return (
            <>
                {cartSlots.map((slot) => (
                    <div key={slot.slotId} className={prodCatridgeClassName}>
                        <RecommendationSwitch
                            strategy={slot.slotId}
                            pageType={pageType}
                            itemId={slot.requiresItemId ? itemId : ''}
                        />
                    </div>
                ))}
            </>
        );
    }

    render() {
        const {
            orderItems,
            orderAdjustments,
            showGlobalLoader,
            orderInfo,
            orderInfo: { itemsCount = 0 } = {},
            loadEmptyCart,
            deviceType,
            updateCartItemInit,
            actions,
            orderCharges,
            oosDetails,
            quantityChangedItems,
            coCoupons,
            showButtonActionProgress,
            lastRemovedCartItem,
            productDetailsSliderStatus,
            enableNewOrderSummaryRedesign,
            enableBestCouponCTA,
            roundUpCharity,
            openChangeStoreSlider = {},
            deviceType: { isDesktop },
            savedItemsCount,
            orderSummaryHeight,
            mainContainerHeightOverride,
            syfQuickScreen,
            plccDynamicBanner,
            rewardsPoints,
            disableEarnRewardsBanner,
            stickyParentBlock,
            bxgxPromotionMessages,
            isProtectionModalOpen,
            isShippingProtectionCheckoutModalOpen,
            disableNarvarShippingProtection,
            enableChooseRewardSlider,
        } = this.props;
        const shouldShowPlcc = plccDynamicBanner?.displayPlccBanner;
        const { eligible, getQSEligibleCalledSuccess, SYFScriptFailed } = syfQuickScreen;
        const { enableQSBanner, showQSBannerInS1Slot } = this.state;
        let renderRegularBannerOverQS = !enableQSBanner;
        let adjustStickyHeight = false;
        if (enableQSBanner) {
            const isQSNotEligiblefromAPI = getQSEligibleCalledSuccess && !eligible;
            renderRegularBannerOverQS =
                showQSBannerInS1Slot || SYFScriptFailed || isQSNotEligiblefromAPI;
            adjustStickyHeight =
                getQSEligibleCalledSuccess && eligible && !showQSBannerInS1Slot && !SYFScriptFailed;
        }
        if (openChangeStoreSlider.triggerSliderOpen) {
            actions.resetChangeStoreSlider();
            this.openFindStoreSlider(openChangeStoreSlider);
        }

        const currency = orderInfo.currency ? orderInfo.currency : CURRENCY_US;
        if (loadEmptyCart) {
            !__SERVER__ &&
                (deviceType.isTablet || deviceType.isMobile) &&
                document.body.classList.remove('cartBodyPadding'); // NOSONAR
            return (
                <div>
                    <ServiceErrorMessage
                        contextList={this.state.contextList}
                        componentName="CART_SECTION"
                    />
                    <div className={dt(['mx-6'])}>{this.renderS1()}</div>
                    {enableQSBanner ? (
                        <div
                            className={dt(['my-7', 'lg:w-[66.67%]', 'lg:mx-auto', 'smMd:mx-6'])}
                            data-automation-id="at-QS-Emptycart"
                        >
                            <QuickScreenLazy bannerType="Row" />
                        </div>
                    ) : (
                        ''
                    )}
                    <EmptyCart
                        isUserNotLoggedIn={!User.isUserLoggedIn()}
                        openSignInSlider={this.props.actions.openSignInSlider}
                    />
                </div>
            );
        }
        if (isEmpty(orderItems)) {
            return null;
        }

        const activeLoaderClass = showGlobalLoader ? 'progress-active' : '';
        const showActionProgress = showButtonActionProgress ? 'progress-active' : '';
        const iPadFound = !__SERVER__ && !!navigator.userAgent.match(/iPad/g);
        !__SERVER__ &&
            (deviceType.isTablet || deviceType.isMobile || iPadFound) &&
            document.body.classList.add('cartBodyPadding'); // NOSONAR
        let displayShippingThresholdHeader = false;
        const shippingArray = [];
        for (let i = 0; i < orderItems.length; i += 1) {
            const item = orderItems[i];
            const shippingItem = find(
                item.deliveryOptions,
                (option) => option.code === 'HOME' && option.selected
            );
            if (shippingItem) {
                shippingArray.push(shippingItem);
            }
            if (item.product.truckable && item.product.type !== 'LARGEAPPLIANCE') {
                displayShippingThresholdHeader = false;
                break;
            } else {
                /* istanbul ignore next */
                displayShippingThresholdHeader = true;
            }
            if (shippingArray.length > 0) {
                displayShippingThresholdHeader = true;
            } else {
                displayShippingThresholdHeader = false;
            }
        }

        const isNotAGiftCardOrder = !isGiftCardOrderOnly(this.props.orderItems);

        const appliedRewardObject = {
            count: 0,
            amount: 0,
        };

        forEach(orderAdjustments, (item) => {
            if (item.code === ADJUSTMENT_TYPE_REWARD) {
                appliedRewardObject.count = item.count || 0;
                appliedRewardObject.amount = item.amount || 0;
            }
        });

        /* istanbul ignore next */
        let isTotalExceededError = false;
        const cartErrorCode = ['SRV_ORDER_TOTAL_EXCEEDS'];
        let cartErrorExceptions = '';
        let cartErrorMessage = '';
        if (get(orderInfo, 'status.exceptions')) {
            /* istanbul ignore next */
            cartErrorExceptions = map(orderInfo.status.exceptions, 'errorCode');
            const totalExceededException = find(orderInfo.status.exceptions, {
                errorCode: 'SRV_ORDER_TOTAL_EXCEEDS',
            });
            cartErrorMessage = get(totalExceededException, 'errorMessage', '');
        }
        /* istanbul ignore next */
        if (
            !isEmpty(cartErrorExceptions) &&
            !isEmpty(intersection(cartErrorCode, cartErrorExceptions))
        ) {
            isTotalExceededError = true;
            if (!this.totalExceededErrorAnalyticsTriggered) {
                this.props.actions.triggerFormError([{ errorDescription: cartErrorMessage }]);
                this.totalExceededErrorAnalyticsTriggered = true;
            }
        }

        const shippingCharge = find(
            orderCharges,
            (charge) => charge.type === 'SHIPPING AND HANDLING'
        );
        const isShippingFree =
            orderInfo.isPriceAccurate && shippingCharge && shippingCharge.amount === 0;
        const appliedCoupon = this.appliedCouponBestOrOnline();
        const bestCouponOrApplied =
            !this.showFPACExperience(coCoupons, orderAdjustments) && isEmpty(appliedCoupon);

        const isNotAGiftCardOrderVal = isNotAGiftCardOrder;
        return (
            <div
                className={`${cx(
                    'cartContentWrapper',
                    'tailwindGrid',
                    activeLoaderClass,
                    showActionProgress
                )} ${dt(['mx-6'])}`}
                data-automation-id="at-cart-content-wrapper"
            >
                {activeLoaderClass && isEmpty(updateCartItemInit) && <DelaySpinner />}
                {this.renderS1()}
                <div
                    className={`${cx('sm12', 'md12', 'lg8', 'xl8')} ${dt(['sm:!p-0', 'lg:!pr-2'])}`}
                >
                    <div className={dt(['mt-4', 'lg:py-2', 'lg:px-0'])}>
                        {enableQSBanner && showQSBannerInS1Slot ? (
                            <div
                                className={eligible ? dt(['mt-2', 'mb-6']) : ''}
                                data-automation-id="at-QS-s1"
                            >
                                <QuickScreenLazy bannerType="Row" />
                            </div>
                        ) : (
                            ''
                        )}
                        <CartMessages
                            isTotalExceededError={isTotalExceededError}
                            cartTotalExceededErrorMsg={cartErrorMessage}
                            bxgxPromotionMessages={bxgxPromotionMessages}
                        />
                    </div>
                    {isNotAGiftCardOrderVal && enableBestCouponCTA && (
                        <section
                            className={`${cx('visibleSmMd', 'couponOuterWrapper')} ${dt([
                                'pb-3',
                                'text-center',
                                'my-0',
                                'mx-auto',
                            ])}`}
                        >
                            {this.renderFPACorBestCoupon(true)}
                        </section>
                    )}
                    <div>
                        <div
                            className={dt([
                                'border-b',
                                'border-solid',
                                'border-gray-15',
                                'lg:mr-4',
                                'sticky',
                                'top-0',
                                'bg-white',
                                'z-[4]',
                            ])}
                        >
                            <div
                                className={dt([
                                    'mb-3',
                                    'font-open-sans-regular',
                                    'text-black',
                                    'flex',
                                    'justify-between',
                                    'items-center',
                                ])}
                            >
                                <span className={dt(['text-2xlarge'])}>
                                    <strong>Cart</strong>&nbsp;
                                    {`(${itemsCount} ${itemsCount === 1 ? 'item' : 'items'})`}
                                </span>
                                {!!savedItemsCount && (
                                    <Button
                                        automationId="at-saved-for-later-link"
                                        buttonType="Link"
                                        size="Md"
                                        onClick={this.scrollToSFL}
                                    >
                                        {`${savedItemsCount} saved ${
                                            savedItemsCount === 1 ? 'item' : 'items'
                                        }`}
                                    </Button>
                                )}
                            </div>
                        </div>
                        {!disableEarnRewardsBanner && !__SERVER__ && !isTotalExceededError && (
                            <EarnRewardsPointsLazy
                                otherCard={rewardsPoints?.otherPaymentPoints}
                                jcpCard={rewardsPoints?.jcpPaymentPoints}
                                pointsAway={rewardsPoints?.otherPaymentPointsAway}
                                jcpPointsAway={rewardsPoints?.jcpPointsAway}
                                otherCashPassEarned={rewardsPoints?.otherCashPassEarned}
                                jcpCashPassEarned={rewardsPoints?.jcpCashPassEarned}
                                plccDynamicBanner={plccDynamicBanner}
                                getPLCCDetailsHtml={this.props.actions.getPLCCDetailsHtml}
                                isNative={this.props.isNative}
                                isNativeAndroid={this.props.isNativeAndroid}
                                androidVersion={get(
                                    this.props,
                                    'preferences.lnlVersions.androidMinVersion',
                                    ''
                                )}
                                isCreateAccountSuccess={
                                    this.props?.signInSliderDetails?.authenticationSuccess &&
                                    this.props?.signInSliderDetails?.confirmCreateAccountPage
                                }
                                showChooseRewardsSlider={this.props?.signInSliderDetails?.showChooseRewardsSlider}
                                isSignInSliderOpen={this.props?.signInSliderDetails?.isSliderOpen || this.props?.signInSliderDetails?.mountSignInSlider }
                                enableChooseRewardSlider={enableChooseRewardSlider}
                                siteCode={get(
                                    this.props,
                                    'preferences.plccBanner.rewardsBannerSiteCode',
                                    ''
                                )}
                            />
                        )}
                        <div
                            className={`${cx('cartItemsWrapper')} ${dt([
                                'flex',
                                'flex-col',
                                'items-start',
                                'mt-6',
                                'lg:flex-col-reverse',
                                'lg:mb-4',
                            ])}`}
                            data-automation-id="at-cart-page-items-wrapper"
                        >
                            <div className={dt(['w-full'])}>
                                <CartItemsList
                                    orderItems={orderItems}
                                    lastRemovedCartItem={lastRemovedCartItem}
                                    orderAdjustments={orderAdjustments}
                                    currency={currency}
                                    deviceType={deviceType}
                                    quantityChangedItems={quantityChangedItems}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={cx('visibleSmMd')}>
                        {!isDesktop && renderRegularBannerOverQS && (
                            <CartBanners togglePLCCDetailSlider={this.togglePLCCDetailSlider} />
                        )}
                    </div>
                    {!isDesktop && !renderRegularBannerOverQS ? (
                        <div
                            className={`${cx('visibleSmMd')} ${dt([
                                'mx-auto',
                                '!px-0',
                                'mt-4',
                                'pb-2',
                            ])}`}
                            data-automation-id="at-QS-Mob-Banner"
                        >
                            <QuickScreenLazy bannerType="Banner" />
                        </div>
                    ) : (
                        ''
                    )}
                    {bestCouponOrApplied && isNotAGiftCardOrder && (
                        <div
                            className={`${cx('visibleSmMd', 'rewardsSection', 'todayCoupon')} ${dt([
                                'border-t-0',
                                'border-b-0',
                                'smMd:mx-auto',
                                'smMd:my-0',
                                'mdOnly:w-1/2',
                                !enableNewOrderSummaryRedesign && 'sm:!p-0',
                                enableNewOrderSummaryRedesign && '!pb-[1px]',
                                enableNewOrderSummaryRedesign && '!mb-[-1px]',
                            ])}`}
                            data-automation-id="at-coupon-best-cpn-block"
                        >
                            <FindBestCoupon idSuffix="-mobile" />
                        </div>
                    )}
                    <OrderSummaryWrapperMobile
                        isNotAGiftCardOrder={isNotAGiftCardOrder}
                        handleApplyRewardsSection={() => this.handleApplyRewardsSection(true)}
                        displayShippingThresholdHeader={displayShippingThresholdHeader}
                        isShippingFree={isShippingFree}
                        removeCouponSummary={bestCouponOrApplied}
                        idSuffix="-mobile"
                    />
                    {/*  Adding saved items and rec zones and banners */}
                    {!isEmpty(this.props.cartDetails) && <SavedItemsList />}
                    {this.renderProductCartridge()}
                    {!__SERVER__ && (!isEmpty(this.props.cartDetails) || loadEmptyCart) && (
                        <PageBanners
                            googleBVAdsId={GOOGLE_ADS_CART_PAGE_BOTTOM_LEFT}
                            isJcpCardInOrder={(orderInfo && orderInfo.isJcpCardInOrder) || false}
                            customClass={dt([
                                '-mx-6',
                                '!w-[calc(100%+48px)]',
                                'lg:!w-[calc(100%+40px)]',
                            ])}
                        />
                    )}
                </div>
                <OrderSummaryWrapper
                    stickyParentBlock={stickyParentBlock}
                    mainContainerHeightOverride={mainContainerHeightOverride}
                    adjustStickyHeight={adjustStickyHeight}
                    orderSummaryHeight={orderSummaryHeight}
                    isNotAGiftCardOrder={isNotAGiftCardOrder}
                    renderFPACorBestCoupon={this.renderFPACorBestCoupon}
                    handleApplyRewardsSection={() => this.handleApplyRewardsSection(false)}
                    displayShippingThresholdHeader={displayShippingThresholdHeader}
                    isShippingFree={isShippingFree}
                    renderRegularBannerOverQS={renderRegularBannerOverQS}
                    togglePLCCDetailSlider={this.togglePLCCDetailSlider}
                />
                {roundUpCharity && <RoundupForCharityLearnMore />}
                {(this.props.orderInfo.shippingProtectionSelected ||
                    isFeatureEnabledFromCookie('enableShippingProtection') ||
                    !disableNarvarShippingProtection) && (
                    <>
                        {isProtectionModalOpen && (
                            <ShippingProtectionModalLazy isOpen={isProtectionModalOpen} />
                        )}
                        {/* {isShippingProtectionCheckoutModalOpen && (
                            <ShippingProtectionCheckout
                                isOpen={isShippingProtectionCheckoutModalOpen}
                                amount={this.props.orderInfo?.shippingProtectionAmount}
                            />
                        )} */}
                    </>
                )}
                {this.props.enableSingleClickCheckout &&
                    (this.props?.orderInfo?.status?.singleClickEligible ||
                        this.props.singleClickDataReady) && <SingleClickCheckoutWrapper />}
                {!isEmpty(this.props.productDetails) &&
                    productDetailsSliderStatus &&
                    this.renderAdditionalServices()}
                {oosDetails && oosDetails.showGenericOOSModal && (
                    <OOSModal
                        onClose={this.continueToCart}
                        onCheckout={this.continueToCart}
                        onContinue={this.continueToCart}
                        defaultCloseBtn={this.continueToCart}
                        showGenericModal
                        isShowModal
                    />
                )}
                {this.state.showPLCCDetailSlider && shouldShowPlcc && (
                    <PLCCSlidePanelLazy
                        siteCode={get(this.props, 'preferences.plccBanner.plccBannerSiteCode', '')}
                        togglePLCCDetailSlider={this.togglePLCCDetailSlider}
                    />
                )}
                <LiveChat />
            </div>
        );
    }
}

CartPageWrapper.defaultProps = {
    orderItems: {},
    orderAdjustments: {},
    orderInfo: {},
    showGlobalLoader: false,
    isAdjustmentsUpdated: false,
    deviceType: {},
    updateAdjustmentStatus: { result: false },
    marketingSlotBanner: {},
    updateCartItemInit: '',
    orderCharges: [],
    headers: {},
    plccDynamicBanner: {},
    coCoupons: {},
    coAppliedAdjustments: {},
    enableSupressBestCoupon: false,
    singleClickDataReady: false,
    messageContentData: {},
    showButtonActionProgress: false,
    productDetailsSliderStatus: false,
    interstitialSelectedItem: {},
    defaultRadius: 75,
    isNative: false,
    isNativeAndroid: false,
    savedItemsCount: 0,
    enableBestCouponCTA: true,
    disableCartLineItemReadyForPickupMsg: true,
    enableSingleClickCheckout: true,
    enableNewOrderSummaryRedesign: true,
    enableRewards: true,
    roundUpCharity: true,
    enableGiftCardBanner: true,
    syfQuickScreen: {},
    metaTokenInfo: {},
    context: {},
};

CartPageWrapper.propTypes = {
    actions: PropTypes.objectOf(PropTypes.func).isRequired,
    orderItems: PropTypes.arrayOf(PropTypes.object),
    orderAdjustments: PropTypes.arrayOf(PropTypes.object),
    orderInfo: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    showGlobalLoader: PropTypes.bool,
    isAdjustmentsUpdated: PropTypes.objectOf(),
    loadEmptyCart: PropTypes.bool,
    deviceType: PropTypes.objectOf(PropTypes.bool),
    updateAdjustmentStatus: PropTypes.objectOf(PropTypes.object),
    marketingSlotBanner: PropTypes.objectOf(PropTypes.object),
    updateCartItemInit: PropTypes.string,
    orderCharges: PropTypes.arrayOf(PropTypes.object),
    headers: PropTypes.objectOf(PropTypes.object),
    oosDetails: PropTypes.oneOfType(PropTypes.object).isRequired,
    quantityChangedItems: PropTypes.arrayOf(PropTypes.string),
    plccDynamicBanner: PropTypes.objectOf(PropTypes.object),
    enableSupressBestCoupon: PropTypes.bool,
    coCoupons: PropTypes.objectOf(PropTypes.object),
    coAppliedAdjustments: PropTypes.objectOf(PropTypes.object),
    singleClickDataReady: PropTypes.bool,
    messageContentData: PropTypes.objectOf(PropTypes.object),
    showButtonActionProgress: PropTypes.bool,
    productDetails: PropTypes.arrayOf(PropTypes.object),
    productDetailsSliderStatus: PropTypes.bool,
    interstitialSelectedSkuId: PropTypes.string,
    interstitialSelectedItem: PropTypes.object,
    zipCode: PropTypes.string,
    defaultRadius: PropTypes.number,
    isNative: PropTypes.bool,
    isNativeAndroid: PropTypes.bool,
    enableBestCouponCTA: PropTypes.bool,
    disableCartLineItemReadyForPickupMsg: PropTypes.bool,
    enableSingleClickCheckout: PropTypes.bool,
    enableNewOrderSummaryRedesign: PropTypes.bool,
    enableRewards: PropTypes.bool,
    roundUpCharity: PropTypes.bool,
    enableGiftCardBanner: PropTypes.bool,
    syfQuickScreen: PropTypes.object,
    metaTokenInfo: PropTypes.object,
};

const mapStateToProps = (state) => {
    const deviceType = get(state, 'context.deviceType');
    const showGiftCardBanner = get(state, 'giftCardBannerData.showGiftCardBanner', false);
    const defaultRadius = get(state, 'context.preferences.defaultRadius', 75);
    const preferences = get(state, 'context.preferences');
    const isNative = get(state, 'context.isNative', false);
    const isNativeAndroid = get(state, 'context.isNativeAndroid', false);
    const isProtectionModalOpen = get(state, 'shippingProtectionModal.isModalOpen', false);
    const isShippingProtectionCheckoutModalOpen = get(
        state,
        'shippingProtectionModal.isCheckoutModalOpen',
        false
    );
    const {
        orderItems,
        orderAdjustments,
        orderInfo,
        showGlobalLoader,
        isAdjustmentsUpdated,
        loadEmptyCart,
        updateAdjustmentStatus,
        marketingSlotBanner,
        updateCartItemInit,
        orderCharges,
        cartDetails,
        plccDynamicBanner,
        oosDetails,
        quantityChangedItems,
        coCoupons,
        coAppliedAdjustments,
        SingleClickOrderInfo,
        messageContentData,
        ShowButtonClickProgress,
        lastRemovedCartItem,
        productDetails,
        productDetailsSliderStatus,
        openChangeStoreSlider = {},
        signInSliderDetails = {},
        certonaAttributes,
        context,
        metaTokenInfo,
        bxgxPromotionMessages,
    } = state;
    const headers = get(state, 'context.headers');
    const featureFlags = get(state, 'context.featureFlags');
    const {
        enableSupressBestCoupon = false,
        enableBestCouponCTA = true,
        disableCartLineItemReadyForPickupMsg = true,
        enableSingleClickCheckout = true,
        enableNewOrderSummaryRedesign = true,
        enableRewards = !isAgentLogged(),
        roundUpCharity = true,
        enableGiftCardBanner = true,
        disableEarnRewardsBanner = false,
        disableNarvarShippingProtection = false,
        enableChooseRewardSlider = false,
    } = featureFlags || {};
    const singleClickDataReady = get(SingleClickOrderInfo, 'singleClickDataReady', false);
    const interstitialSelectedSkuId = get(state, 'interstitialSelectedSkuId.selectedSKUID', '');
    const zipCode =
        get(state, 'userStoreLocationInfo.inputZipCode', '') ||
        get(state, 'userStoreLocationInfo.zipcode', '') ||
        get(state, 'findStoresDetails.zipCode', '') ||
        get(state, 'findStoresDetails.zipcode', '');
    const savedItemsCount = get(state, 'savedItems.itemNumber');
    const syfQuickScreen = get(state, 'syfQuickScreen', {});
    const rewardsPoints = get(state, 'cartDetails.data.customerRewardPoints');
    return {
        orderItems,
        orderAdjustments,
        orderInfo,
        showGlobalLoader,
        isAdjustmentsUpdated,
        context,
        loadEmptyCart,
        deviceType,
        updateAdjustmentStatus,
        marketingSlotBanner,
        updateCartItemInit,
        orderCharges,
        headers,
        cartDetails,
        plccDynamicBanner,
        enableSingleClickCheckout,
        oosDetails,
        quantityChangedItems,
        featureFlags,
        enableSupressBestCoupon,
        coCoupons,
        coAppliedAdjustments,
        singleClickDataReady,
        showGiftCardBanner,
        messageContentData,
        showButtonActionProgress: get(ShowButtonClickProgress, 'showProgress', false),
        lastRemovedCartItem,
        productDetailsSliderStatus,
        productDetails,
        ppId: selectPpId(state),
        interstitialSelectedSkuId,
        additionalServices: getAdditionalServices(false)(state),
        interstitialSelectedItem: get(state, 'interstitialSelectedSkuId.selectedItem', ''),
        openChangeStoreSlider,
        zipCode,
        defaultRadius,
        preferences,
        isNative,
        isNativeAndroid,
        enableNewOrderSummaryRedesign,
        enableBestCouponCTA,
        enableRewards,
        roundUpCharity,
        enableGiftCardBanner,
        savedItemsCount,
        disableCartLineItemReadyForPickupMsg,
        syfQuickScreen,
        rewardsPoints,
        disableEarnRewardsBanner,
        signInSliderDetails,
        certonaAttributes,
        metaTokenInfo,
        bxgxPromotionMessages,
        isProtectionModalOpen,
        isShippingProtectionCheckoutModalOpen,
        disableNarvarShippingProtection,
        enableChooseRewardSlider,
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            initGiftCardBannerInfo,
            getMarketingSlotBanner,
            getIrisMarketingSlotBanner,
            getPLCCDetailsHtml,
            getRewardId,
            ...cartDetailsAction,
            ...showGlobalLoaderAction,
            ...findStoresAction,
            ...COAdjustmentAction,
            ...COCouponAction,
            ...siteAnalyticsAction,
            ...splunkLogsActions,
            ...CheckoutAnalyticsAction,
            ...signinActions,
            ...messageContentAction,
            ...applePayAction,
            ...googlePayAction,
            ...slidePanelActions,
            ...atcSliderStatusAction,
            ...ClientLoggerAction,
            ...LocationServiceAction,
            ...changeStoreSliderActions,
            ...serviceErrorActions,
            ...AccessTokenProviderAction,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartPageWrapper);
